module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"overview":"総括"}}')
  delete Component.options._Ctor
}
